import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['collapsible_trigger'];

  connect() {
    this.collapsible = this.data.get('collapsible') || false;
    this.collapsed = this.element.classList.contains('card--collapsed');
  }

  collapse() {
    if (this.collapsible) {
      this.collapsed = !this.collapsed;
      if (this.collapsed) {
        this.element.classList.add('card--collapsed');
      } else {
        this.element.classList.remove('card--collapsed');
      }
    }
  }
}
